export default function PaymentMethodCard({paymentMethod}) {
    return (
        <div className="payment-method-card">
            <div className="brand">{paymentMethod.card.brand}</div>
            <div className="number">**** **** **** {paymentMethod.card.last4}</div>
            <div className="expiration-date">{paymentMethod.card.exp_month}/{paymentMethod.card.exp_year}</div>
        </div>
    )
}